// extracted by mini-css-extract-plugin
module.exports = {"container":"DavidPifView_container__ktleg"};